export const formatLastLogin = (dateStr) => {
  if (!dateStr || dateStr === "null") return "N/A";

  try {
    // Expected: "03-12-2025 15:39:13 IST"
    const [datePart, timePart] = dateStr.split(" ");
    const [day, month, year] = datePart.split("-");
    const [hours, minutes, seconds] = timePart.split(":");

    // Construct a valid ISO date
    const istDate = new Date(
      `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+05:30`
    );

    // Detect user's local timezone automatically
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Convert IST → User Local Time automatically
    return new Date(istDate.toLocaleString("en-US", { timeZone: userTimezone }))
      .toLocaleString("en-US", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
  } catch (error) {
    return dateStr;
  }
};
